import * as Scrivito from 'scrivito';
import { AccordionWidgetId } from '../accordion-widget/accordion-widget-definitions';
import { AccordionElementWidgetAttributes, AccordionElementWidgetId } from './accordion-element-widget-definitions';
import { ButtonWidgetId } from '../button-widget';

export const AccordionElementWidget = Scrivito.provideWidgetClass(AccordionElementWidgetId, {
  attributes: {
    [AccordionElementWidgetAttributes.HEADLINE]: 'string',
    [AccordionElementWidgetAttributes.SUB_HEADLINE]: 'string',
    [AccordionElementWidgetAttributes.TEXT]: 'html',
    [AccordionElementWidgetAttributes.ID]: 'string',
    [AccordionElementWidgetAttributes.IMAGE_BEFORE]: ['reference', { only: 'Image' }],
    [AccordionElementWidgetAttributes.IMAGE_AFTER]: ['reference', { only: 'Image' }],
    [AccordionElementWidgetAttributes.BUTTONS]: ['widgetlist', { only: [ButtonWidgetId] }],
  },
  onlyInside: [AccordionWidgetId],
  extractTextAttributes: [AccordionElementWidgetAttributes.HEADLINE, AccordionElementWidgetAttributes.TEXT],
});

export default AccordionElementWidget;
